import { adminClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { ac, roles } from "./permissions";

export function initClientAuth(options: { baseURL: string }) {
  return createAuthClient({
    baseURL: options.baseURL,
    plugins: [
      adminClient({ ac, roles }),
      // TODO: the role field is already inferred without this plugin but as string | null | undefined.
      // check if the logged in user always has it as string then enable this plugin
      // inferAdditionalFields({ user: { role: { type: "string" } } }),
    ],
  });
}
